import homeThinSvg from "../../img/home-thin.svg";
import homeSvg from "../../img/home.svg";
import { Svg } from "../../utils/svgIcon";

import {
    ApplicationBarVariant,
    useApplicationBarVariant,
} from "./ApplicationBarVariant";
import * as theme from "./Breadcrumbs.css";

export interface BreadcrumbsHomeProps {
    href: string;
}

export function BreadcrumbsHome({ href }: BreadcrumbsHomeProps) {
    const variant = useApplicationBarVariant();

    return (
        <a href={href}>
            <Svg src={homeIcons[variant]} className={theme.homeIcon[variant]} />
        </a>
    );
}

const homeIcons: Record<ApplicationBarVariant, string> = {
    default: homeThinSvg,
    flat: homeSvg,
};
